import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { BlockUIModule } from 'primeng/blockui';
import { firstValueFrom } from 'rxjs';
import { ApiService } from 'src/app/ushers/service/api.service';
import { CookieService } from 'src/app/ushers/service/cookie.service';
import * as _ from 'lodash'; 
import { FieldsetModule } from 'primeng/fieldset';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { Router, RouterModule } from '@angular/router';
import { environment } from 'src/environments/environment.development';
import { MessagesModule } from 'primeng/messages';
import { JwtService } from 'src/app/ushers/service/jwt.service';
import { TabViewModule } from 'primeng/tabview';
import { TagModule } from 'primeng/tag';
import { FormsModule } from '@angular/forms';
import { BadgeModule } from 'primeng/badge';
import { LayoutService } from 'src/app/layout/service/app.layout.service';
import { DropdownModule } from 'primeng/dropdown';
import { ToolbarModule } from 'primeng/toolbar';
import { AvatarModule } from 'primeng/avatar';
import { PanelModule } from 'primeng/panel';
import { Message, MessageService } from 'primeng/api';

@Component({
  selector: 'app-locale-dashboard',
  standalone: true,
  imports: [
    BlockUIModule, 
    CommonModule, 
    FieldsetModule, 
    TableModule, 
    ButtonModule, 
    RouterModule, 
    MessagesModule,
    TabViewModule, 
    TagModule,
    FormsModule,
    BadgeModule,
    DropdownModule,
    ToolbarModule,
    AvatarModule,
    PanelModule
  ],
  templateUrl: './locale-dashboard.component.html',
  styleUrl: './locale-dashboard.component.scss',
  providers: [MessageService]
})
export class LocaleDashboardComponent implements OnInit{
  apiService = inject(ApiService);
  cookieService = inject(CookieService);
  jwtService = inject(JwtService);
  private router = inject(Router);
  layoutService = inject(LayoutService); 

  blockedDocument: boolean = true;
  currentYear: number = new Date().getFullYear();
  weeks:any[] = [];
  inclusiveDates:any[] = [];
  localeName = "";
  statuses:any;
  locales:any;
  access:any;
  selectedLocale:any;
  selectedLocaleName:any;
  name:any;
  photo:any;
  header:any;
  districLocales:any;
  areaId:any;
  errorMessages:any = [];
  selectedYear:any;
  yearOptions = [
    {label: "2024", value : 2024},
    {label: "2025", value : 2025},
    {label: "2026", value : 2026},
    {label: "2027", value : 2027},
    {label: "2028", value : 2028},
    {label: "2029", value : 2029},
    {label: "2030", value : 2030},
  ]

  items: { count: number, label: string, class : string }[] = [];

  ngOnInit() {
    this.name = this.cookieService.getCookie("name");
    this.photo = this.cookieService.getCookie("photo");
    this.selectedLocale = parseInt(this.cookieService.getCookie("selectedLocaleId"));
    this.districLocales = _.split(this.jwtService.getValueOf('district'),',');
    this.areaId = this.jwtService.getValueOf('areaId');
    this.localeName = this.cookieService.getCookie('selectedLocaleName');
    this.access = this.jwtService.getValueOf('roles');

    if(this.cookieService.getCookie("selectedYear")) {
      this.currentYear = parseInt(this.cookieService.getCookie("selectedYear"));
      this.selectedYear = this.currentYear;
    } else {
      this.selectedYear = this.currentYear;
    }

    this.loadFiscalYear();

    this.header = this.localeName + " Locale Dashboard " +this.currentYear;

    if(!this.access.includes("ROLE_MINISTER")) {
      this.loadlocales();
    }
  }

  loadlocales(){
    firstValueFrom(this.apiService.getGC(`${environment.api.gc}/config/locales/all`)).then(res =>{
      var localeList:any = [];
      if(this.access === 'ROLE_ADMIN') {
        localeList = _.filter(res,{countryName : "Philippines"})
      } else if(this.access === 'ROLE_GLOBAL_ADMIN') {
        localeList = _.filter(res, function(locale) {return locale.countryName !== 'Philippines'});
      } else if(this.access === 'ROLE_DISTRICT_ADMIN') {
        var localeId;
        res.forEach((locale:any) => {
          localeId = locale.localeId;
          if(this.districLocales.includes(localeId.toString())) {
            localeList.push(locale);
          }
        });
      }else {
        localeList = res;
      }
      this.locales = localeList;
    }).catch(err =>{
      console.log(err)
      this.handleErrorMessages(err);
      this.blockedDocument = false;
    });
}


  loadFiscalYear(){
    this.blockedDocument = true;
    var api = environment.api.ushers + "/fiscal-year/year?value=" + this.currentYear;
    firstValueFrom(
      this.apiService.get(api))
    .then((res:any) =>{
      this.weeks = res.result;
      this.loadInclusiveDates();
    }).catch(err =>{
      console.log(err);
      this.handleErrorMessages(err);
      this.blockedDocument = false;
    });
  }

  defaultValues:any[] = [];
  loadInclusiveDates(){
    var localeId = this.cookieService.getCookie("selectedLocaleId");
    var api = environment.api.ushers + "/inclusive-dates/calendar?localeId=" + localeId + "&year=" + this.currentYear;

    firstValueFrom(
      this.apiService.get(api))
    .then((res:any) =>{
      this.inclusiveDates = res.result;
      this.items = [
      { count: this.getEncodedNeed(), label: 'Encoding Needed' , class : 'encoding' },
      { count: this.getStatus("DRAFT"), label: 'Draft' , class : 'draft'  },
      { count: this.getStatus("SUBMITTED"), label: 'Submitted' , class : 'submitted'  },
      { count: this.getStatus("IN_REVIEW"), label: 'In-Review' , class : 'inreview'  },
      { count: this.getStatus("ACKNOWLEDGED"), label: 'Acknowledged' , class : 'acknowledged'  }]
      

      this.weeks.forEach(week =>{
        week.status = this.getStatusByFiscalId(week.id).status;
        week.postingPeriodId = this.getStatusByFiscalId(week.id).id;
      })

      this.weeks = _.reverse(this.weeks);
      this.defaultValues = this.weeks;
      this.weeks = _.filter(this.weeks,['status','ENCODING NEEDED']);  
      this.blockedDocument = false;
    }).catch(err =>{
      console.log(err)
      this.handleErrorMessages(err);
      this.blockedDocument = false;
    });
  }

  getStatus(status : string){
   var arr = _.filter(this.inclusiveDates,{ status : status});
   return arr.length;
  }
  getEncodedNeed(){
    var encodedNeed = this.weeks.length - this.inclusiveDates.length;
    return encodedNeed;
  }

  getStatusByFiscalId(fiscalId : any){
    var transactionRecord = _.filter(this.inclusiveDates,{ fiscalYearId : fiscalId});
    if(transactionRecord.length > 0 ){
      return transactionRecord[0];
    }
   return {
    id: null,
    status : 'ENCODING NEEDED'
   };
  }

  createAndRedirect(args:any){
    this.blockedDocument = true;
    var body = {
      "postingPeriodId" : args.id,
      "localeId" : parseInt(this.cookieService.getCookie("selectedLocaleId"))
    };
    var api = environment.api.ushers + "/inclusive-dates/create" ;
    firstValueFrom(
      this.apiService.post(api,body))
    .then((res:any) =>{
      
      this.router.navigate(['/encoding/weekly-report/' + res.id]);
      this.blockedDocument = false;

    }).catch(err =>{
      this.handleErrorMessages(err);
      this.blockedDocument = false;
    });
  }

  changeTab($event : any){
    this.weeks = this.defaultValues;
    if($event.index == 3) {
      this.weeks = _.filter(this.weeks,['status','IN_REVIEW']);
    } else {
      this.weeks = _.filter(this.weeks,['status',this.items[$event.index]['label'].toLocaleUpperCase()]);
    }
  }

  onSelect(event:any) {
    this.selectedLocale = event.value;
    this.selectedLocaleName = _.filter(this.locales,{'localeId' : this.selectedLocale});
    this.selectedLocaleName = this.selectedLocaleName[0].localeName;
    this.cookieService.setCookie({
        name: 'selectedLocaleId',
        value: this.selectedLocale,
        session: true,
    });
    this.cookieService.setCookie({
        name: 'selectedLocaleName',
        value: this.selectedLocaleName,
        session: true,
    });
    window.location.reload();
  }

  handleErrorMessages(errors:any) {
    var message:string = "";
    message = errors.message

    if(errors.error != null) {
      if(errors.error.errorMessage) {
        message= message +" ("+errors.error.errorMessage + ") ";
      } else {
        message= message +" ("+errors.error.error + ") ";
      }
    }
    this.errorMessages.push(message);
  }

  year:any;
  onSelectYear(event:any) {
    this.year = event.value;
    this.cookieService.setCookie({
      name: 'selectedYear',
      value: this.year,
      session: true,
  });
    this.ngOnInit();
  }
}
